import { cn } from "../../utils/cn"

export function Button({
  className,
  variant,
  ...props
}) {

  const _variant = {
    primary: "",
    secondary: "flex items-center gap-3 py-1.5 px-2 border border-gray-300 rounded bg-white hover:bg-gray-100 cursor-pointer",
  }

  const _className = _variant[variant] || _variant.primary

  return (
    <button
      className={cn(_className, className)}
      {...props}
    />
  )
}
